<template>
  <div class="number-field-container">
    <v-btn
      color="secondary"
      icon
      :disabled="disabled"
      @click="decrementValue"
    >
      <v-icon>
        mdi-minus
      </v-icon>
    </v-btn>
    <v-text-field
      class="centered"
      v-bind="textFieldConfig"
      :rules="validateRules()"
      clearable
      @input="updateValue"
    />
    <v-btn
      color="secondary"
      icon
      :disabled="disabled"
      @click="incrementValue()"
    >
      <v-icon>
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NumberField',
  props: {
    increment: {
      type: Number,
      default: 1
    },
    decrement: {
      type: Number,
      default: 1
    },
    decimals: {
      type: Number,
      default: 0
    },
    trimDecimals: Boolean,
    currency: Boolean,
    label: String,
    disabled: Boolean,
    value: [Number, String],
    minimumValue: Number,
    maximumValue: Number,
    required: Boolean,
    rules: {
      type: Array,
      default () {return []}
    },
    placeholder: [String, Number],
  },
  data () {
    return {}
  },
  computed: {
    prefix () {
      return this.currency ? '$' : ''
    },
    textFieldConfig () {
      let config = {}
      const {prefix, label, disabled, value, required, placeholder} = this.$props
      if (placeholder) config.placeholder = placeholder.toString()
      return Object.assign(config, {prefix, label, disabled, value, required})
    }
  },
  methods: {
    incrementValue () {
      this.updateValue((parseFloat(this.value || 0) + this.increment).toFixed(this.decimals))
    },
    decrementValue () {
      this.updateValue((parseFloat(this.value || 0) - this.decrement).toFixed(this.decimals))
    },
    updateValue (newValue) {
      this.$emit('input', newValue || undefined)
    },
    validateRules () {
      return [
        (v) => {
          if (this.rules) {
            for (let rule of this.rules) {
              const result = rule(v)
              if (result !== true) return result
            }
            return true
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
.number-field-container {
  display: flex;
  align-items: center;
}
.centered >>> input {
  text-align: center;
}
</style>